import { createGlobalStyle } from 'styled-components';
import { MAIN_BLUE } from './Colors';

const GlobalStyle = createGlobalStyle`
  *{
    box-sizing:border-box
  }
  html{
    scroll-behavior: smooth;
  }
  body {
    margin: 0;
    padding: 0;
    font-family: 'Oswald';
    color: ${MAIN_BLUE}
  }

  a{
      color: inherit;
      text-decoration:none;
  }
`;

export default GlobalStyle;
